module.exports = __webpack_public_path__ + "streamer.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-devices/assets/streamer.svg
// module id = 1153
// module chunks = 10